export const stringFilters = {
    // 37061234567 to 370 612 34567
    phoneBeautify: (val: string) => {
        if (! val) {
            return;
        }
        let string = '';
        const parts = val.split('');

        let counter = 0;
        for (const part of parts) {
            if (counter === 3 || counter === 6) {
                string += ' ';
            }
            string += part;

            counter++;
        }
        return '+' + string;
    }
}